import { WebGLRenderer } from "three";
import { getContainerSize } from "./config";

function createRenderer(container) {
  const renderer = new WebGLRenderer({ antialias: true, alpha: true });
  const { width, height } = getContainerSize(container);

  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.setSize(width, height);
  renderer.setClearColor(0x000000, 0);

  return renderer;
}

export { createRenderer };
